<template>
    <div>
        <b-alert v-show="!inReview" variant="info" :show="true">
            <h4 class="alert-heading">
                <i class="fa fa-info-circle" />
                {{ $t("pages.forms.sample.sample-id.about.title") }}
            </h4>
            <p>
                {{ $t("pages.forms.sample.sample-id.about.description.p1") }}
                (<span class="text-info">PGLXXXXX/OGLXXXXX</span>).
                <span style="font-weight: bolder">{{
                    $t("pages.forms.sample.sample-id.about.description.p2")
                }}</span>
            </p>
            <p>
                {{ $t("pages.forms.sample.sample-id.about.description.p3") }}
            </p>
        </b-alert>
        <b-form-group :label-for="id" v-show="!inReview">
            <template slot="label"><slot name="label"></slot></template>
            <validation-provider
                :rules="{ required }"
                :vid="id"
                v-slot="{ dirty, validated, valid, errors }"
            >
                <b-form-radio-group
                    :id="id"
                    v-model="fieldValue"
                    :options="PglOgl"
                    :state="dirty || validated ? valid : null"
                    :required="required"
                    @input="update"
                    @change="change"
                    v-show="!inReview"
                >
                    <b-form-invalid-feedback
                        :state="dirty || validated ? valid : null"
                        >{{ errors[0] }}</b-form-invalid-feedback
                    >
                </b-form-radio-group>
            </validation-provider>
            <b-form-input
                type="text"
                readonly
                plaintext
                :value="fieldValueForReview"
                v-show="false"
            />
        </b-form-group>
    </div>
</template>

<script>
import FormInputHelpers from "../../mixins/FormInputHelpers";
import { ValidationProvider } from "vee-validate";

export default {
    mixins: [FormInputHelpers],
    components: { ValidationProvider },
    data() {
        return {
            fieldValue: null
        };
    },
    props: {
        id: String,
        required: Boolean,
        inReview: Boolean,
        value: null
    },
    methods: {
        update(value) {
            this.$emit("input", value);
        },
        change(value) {
            this.$emit("change", value);
        }
    },
    computed: {
        fieldValueForReview() {
            return this.fieldValue;
        }
    }
};
</script>

<style scoped></style>
